import { ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService, StoreService, UiService } from '@seu-services';

export type SeuOutletsConfig = {
  overview?: SeuNavigationOutletKey;
  detail?: SeuNavigationOutletKey;
};

export type SeuNavigationSideItem = {
  key: SeuNavigationSideItemKey;
  outlets: SeuOutletsConfig;
};

export type SeuNavigationOutletKey =
  | 'offer-details'
  | 'global-values'
  | 'operating-conditions'
  | 'components'
  | 'changelog';

export type SeuNavigationSideItemKey = SeuNavigationOutletKey;

export const SEU_NAVIGATION_SIDE_ITEMS: SeuNavigationSideItem[] = [
  {
    key: 'offer-details',
    outlets: {
      detail: 'offer-details',
    },
  },
  {
    key: 'global-values',
    outlets: {
      overview: 'global-values',
    },
  },
  {
    key: 'operating-conditions',
    outlets: {
      overview: 'operating-conditions',
    },
  },
  {
    key: 'components',
    outlets: {
      overview: 'components',
    },
  },
  {
    key: 'changelog',
    outlets: {
      overview: 'changelog',
    },
  },
];

export type SeuNavigationTopVariant = 'offers' | 'offer-detail';

export type SeuNavigationFlapSize = 'S' | 'M';

export type SeuNavigationSideComponentConstructor = {
  _uiService: UiService;
  _store: StoreService;
  _router: Router;
  _navigationService: NavigationService;
  _dialog: MatDialog;
  _activatedRoute: ActivatedRoute;
  _elementRef: ElementRef;
};
